var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"country-mark",attrs:{"src":_vm.svg}})
}
var staticRenderFns = []

export { render, staticRenderFns }